import { render, staticRenderFns } from "./MenuLateralHeader.vue?vue&type=template&id=15e2c6c7&scoped=true&"
import script from "./MenuLateralHeader.vue?vue&type=script&lang=js&"
export * from "./MenuLateralHeader.vue?vue&type=script&lang=js&"
import style0 from "./MenuLateralHeader.vue?vue&type=style&index=0&id=15e2c6c7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e2c6c7",
  null
  
)

export default component.exports